import { Component, OnInit } from "@angular/core";
import { ProvideMenuService } from "../services/api/provide-menu.service";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-select-menu",
  templateUrl: "./select-menu.component.html",
  styleUrls: ["./select-menu.component.scss"],
})
export class SelectMenuComponent implements OnInit {
  menus: any;
  selectedMenus: any[] = [];
  constructor(
    private service: ProvideMenuService,
    private toast: MessageService,
    private router: Router
  ) {}
  setMenus(menus) {
    this.service.enableMenus(menus).subscribe(
      (res) => {
        this.selectedMenus = [];
        this.toast.add({
          severity: "success",
          summary: "Success",
          detail: "Menu Updated successfully!!!",
        });
        setTimeout(() => {
          this.router
            .navigateByUrl("/", { skipLocationChange: true })
            .then(() => {
              this.router.navigate(["/provide-menu/select-menu"]);
            });
        }, 1000);
      },
      (error) => {
        this.toast.add({
          severity: "error",
          summary: "Error",
          detail: "Menu Update Failed!!!",
        });
      }
    );
  }
  submit() {
    this.setMenus(this.selectedMenus);
  }
  checkAllOptions(event){
    
    this.menus.forEach(ele => {
      if(event == true){
        ele.isEnabled=true;
      }else{
        ele.isEnabled = false;
      }
      this.onMenuChecked(ele);
    });

  }

  onMenuChecked(menu) {

    this.selectedMenus.push(menu);
  }
  getMenus() {
    this.service.getMenus().subscribe((res: any) => {
      this.menus = res;
    });
  }
 
  ngOnInit() {
    this.getMenus();
  }
}
